import React from 'react';
import { Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const TemplateCardView = ({ templates, selectedTemplate, setSelectedTemplate }) => {
  return (
    <Grid container spacing={3}>
      {templates.map((template) => (
        <Grid item xs={12} sm={6} md={4} key={template.value}>
          <Card 
            onClick={() => setSelectedTemplate(template.value)}
            sx={{
              cursor: 'pointer',
              transition: 'all 0.3s',
              '&:hover': {
                transform: 'translateY(-5px)',
                boxShadow: 3,
              },
              border: selectedTemplate === template.value ? '2px solid #1976d2' : 'none',
            }}
          >
            <CardContent>
              <Typography variant="h6" component="div" gutterBottom style={{overflowWrap:"break-word"}}>
                {template.name}
              </Typography>
              {selectedTemplate === template.value && (
                <Link
                  to="/view-survey-questionnaire"
                  state={{
                   
                    id: template.value,
                    viewType:"modify",
                  }}
                  style={{ textDecoration: 'none' }}
                >
                  <Button variant="outlined" fullWidth>
                    View
                  </Button>
                </Link>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default TemplateCardView;

